import React, { useCallback, useEffect } from 'react'
import M_TableCell from 'components/1_Atoms/2_Molecules/M_TableCell'
// import * as TableJuryoAction from 'slicers/TableSlicers/TableJuryoSlice'
import { getTimestampFromNumber } from 'utils/dateUtil'
import { organismLog } from 'utils/logUtil'
import { juryoTable } from 'assets/TableHeader'
import { groupList } from 'types/SearchTypes'
import { useHistory } from 'react-router-dom'
import { useClickNohinYmd, useClickTenpo, useClickTokuisaki, useDetailView } from 'hooks/useJuryo'

const width = juryoTable.width
const manualMode = process.env.REACT_APP_MANUAL_MODE === '1'

type Props = {
  group: groupList
}

const O_TableRowJokenMobileSummary = ({ group }: Props) => {
  useEffect(() => organismLog('O_TableRowJokenMobileSummary'))
  const history = useHistory()
  const [_1, changeDetailView] = useDetailView()
  const [_2, changeClickNohinYmd] = useClickNohinYmd()
  const [_3, changeClickTokuisakiCode] = useClickTokuisaki()
  const [_4, changeClickTenpoCode] = useClickTenpo()

  // チェック処理 //================================//
  const handleRowClick = useCallback(() => {
    changeDetailView(true)
    changeClickNohinYmd(group.NOHIN_YMD)
    changeClickTokuisakiCode(group.TOKUI_CD)
    changeClickTenpoCode(group.TEN_CD)
    history.push('/juryohyo/' + [group.NOHIN_YMD, group.TOKUI_CD, group.TEN_CD].join('-'))
  }, [group])

  // 受領区分の表示名を取得 //================================//
  const getJuryoKbnName = (JURYO_KBN: 0 | 1 | 2 | 11 | 12) => {
    if (JURYO_KBN === 0) return '未受領'
    if (JURYO_KBN === 1) return '受領済'
    if (JURYO_KBN === 2) return '確認依頼'
    if (JURYO_KBN === 11) return '受領済他'
    if (JURYO_KBN === 12) return '確認依頼他'
    return ''
  }

  return (
    <>
      {/* No */}
      {/* <M_TableCell category="number" data={no} width={width.NO} click={handleRowClick} /> */}
      {/* チェックボックス */}
      {/* 受領区分 */}
      <M_TableCell
        category="data" //
        width={width.JURYO_KBN}
        align={'left'}
        title={getJuryoKbnName(group.JURYO_KBN)}
        data={getJuryoKbnName(group.JURYO_KBN)}
        click={handleRowClick}
      />
      {/* 伝票日付 */}
      <M_TableCell
        category="data" //
        width={width.NOHIN_YMD}
        align={'left'}
        title={getTimestampFromNumber(group.NOHIN_YMD, '/')}
        data={getTimestampFromNumber(group.NOHIN_YMD, '/')}
        click={handleRowClick}
      />
      {/* 得意先名 */}
      <M_TableCell
        category="data" //
        width={width.TOKUI_NM}
        align={'left'}
        title={group.TOKUI_NM}
        data={group.TOKUI_NM}
        click={handleRowClick}
        blackout={manualMode}
      />
      {/* 店舗名 */}
      <M_TableCell
        category="data" //
        width={width.TEN_NM}
        align={'left'}
        title={group.TEN_NM}
        data={group.TEN_NM}
        click={handleRowClick}
        blackout={manualMode}
      />
    </>
  )
}

export default React.memo(O_TableRowJokenMobileSummary)
